import React, { createRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import posed from 'react-pose';

const Container = styled.div`
  background: linear-gradient(to right, #0feece, #39fff7, #3abaff, #7757d8);
  color: #ffffff;
  font-size: 40px;
  font-weight: 500;
  overflow-x: hidden;
`;

const Box = posed.div({
  move: {
    x: (props: any) => {
      return props.positonX;
    },
    transition: {
      ease: 'linear',
      duration: 10000,
      loop: 999999999
    }
  }
});

export default () => {
  const [init, setInit] = useState(false);
  const [positonX, setPositonX] = useState(0);

  const ref = createRef<HTMLDivElement>();
  useEffect(() => {
    setInit(true);
    if (ref.current) {
      setPositonX(-ref.current.clientWidth / 2);
    }
  }, [ref]);

  return (
    <Container className="marquee-text-container">
      <Box pose={init ? 'move' : ''} positonX={positonX}>
        <div ref={ref} className="marquee-text">
          Tune in to our VIRTUAL Farmers Market, every Sunday from 10am-1pm
          (PST). Tune in to our VIRTUAL Farmers Market, every Sunday from
          10am-1pm (PST)
        </div>
      </Box>
    </Container>
  );
};
